import { createRouter, createWebHistory } from 'vue-router'
import { userStore } from '@/stores/userstore'

const LandingPage = () => import('@/views/LandingPage.vue')
const MemasSettings = () => import('@/views/MemasSettings.vue')
const EndUser = () => import('@/views/EndUser.vue')
// const PrimaryUser = () => import('@/components/users/PrimaryUser.vue')
const NewPrimaryUser = () => import('@/components/users/NewPrimaryUser.vue')
const SelectDiagnosis = () => import('@/views/SelectDiagnosis.vue')
const SelectQuestionnaire = () => import('@/views/SelectQuestionnaire.vue')
const SelectLearning = () => import('@/views/SelectLearning.vue')
const SystemSetup = () => import('@/views/SystemSetup.vue')
const CalendarManagement = () => import('@/views/CalendarManagement.vue')
const UserLogs = () => import('@/views/UserLogs.vue')
const UserManuals = () => import('@/views/UserManuals.vue')
const SelfReporting = () => import('@/views/SelfReporting.vue')
const BrainTrain = () => import('@/views/BrainTrain.vue')
const DailyHelp = () => import('@/views/DailyHelp.vue')
const PleasureEntertainment = () => import('@/views/PleasureEntertainment.vue')
const VideoManagement = () => import('@/views/VideoManagement.vue')
const ContactInformation = () => import('@/views/ContactInformation.vue')
const LoggedIn = () => import('@/views/LoggedIn.vue')
const Callback = () => import('@/views/LoginCallback.vue')
const AboutMemas = () => import('@/views/AboutMemas.vue')
const PrivacyPage = () => import('@/views/PrivacyPage.vue')
const UserAccounts = () => import('@/views/UserAccounts.vue')
const ErrorPage = () => import('@/views/ErrorPage.vue')
const MemasAdminWebCalendar = () =>
  import('@/components/calendar/MemasAdminWebCalendar.vue')
// const ConsumerUser = () => import('@/components/users/ConsumerUser.vue')
const InstitutionalUser = () => import('@/views/InstitutionalUser.vue')
const MicrosoftLogin = () =>
  import('@/components/login/auth/MicrosoftLogin.vue')
const GoogleLogin = () => import('@/components/login/auth/GoogleLogin.vue')
const MicrosoftCallback = () =>
  import('@/components/login/auth/MicrosoftCallback.vue')
const SubscriptionCallback = () => import('@/views/SubscriptionCallback.vue')
/*
const InstitutionFar = () => import('@/views/InstitutionFar.vue')
const InstitutionHins = () => import('@/views/InstitutionHins.vue')
const InstitutionIncra = () => import('@/views/InstitutionIncra.vue')
*/

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/enduser',
      name: 'EndUser',
      component: EndUser
    },
    /*
    {
      path: '/puser',
      name: 'PrimaryUser',
      component: PrimaryUser
    },
 */
    {
      path: '/newpuser',
      name: 'NewPrimaryUser',
      component: NewPrimaryUser
    },

    {
      path: '/userlogs',
      name: 'UserLogs',
      component: UserLogs,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/system',
      name: 'SystemSetup',
      component: SystemSetup,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/selectdiagnosis',
      name: 'SelectDiagnosis',
      component: SelectDiagnosis,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/selectlearning',
      name: 'SelectLearning',
      component: SelectLearning,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/selectquestionnaire',
      name: 'SelectQuestionnaire',
      component: SelectQuestionnaire,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/usermanuals',
      name: 'UserManuals',
      component: UserManuals
    },
    {
      path: '/useraccounts',
      name: 'UserAccounts',
      component: UserAccounts
    },
    {
      path: '/calendarmanagement',
      name: 'CalendarManagement',
      component: CalendarManagement,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/selfreporting',
      name: 'SelfReporting',
      component: SelfReporting,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/braintrain',
      name: 'BrainTrain',
      component: BrainTrain,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/dailyhelp',
      name: 'DailyHelp',
      component: DailyHelp,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/videomanagement',
      name: 'VideoManagement',
      component: VideoManagement,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/pleasure',
      name: 'PleasureEntertainment',
      component: PleasureEntertainment,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/contact',
      name: 'ContactInformation',
      component: ContactInformation
    },
    {
      path: '/loggedin',
      name: 'LoggedIn',
      component: LoggedIn
    },
    {
      path: '/about',
      name: 'AboutMemas',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: AboutMemas
    },
    {
      path: '/settings',
      name: 'MemasSettings',
      component: MemasSettings
    },
    {
      path: '/privacy',
      name: 'PrivacyPage',
      component: PrivacyPage
    },
    /*
    {
      path: '/consumer',
      name: 'ConsumerUser',
      component: ConsumerUser
    },
    */
    {
      path: '/institutional',
      name: 'InstitutionalUser',
      component: InstitutionalUser
    },
    /*
    {
      path: '/instIncra',
      name: 'InstitutionIncra',
      component: InstitutionIncra
    },
    {
      path: '/instFar',
      name: 'InstitutionFar',
      component: InstitutionFar
    },
    {
      path: '/instHins',
      name: 'InstitutionHins',
      component: InstitutionHins
    },
    */
    {
      path: '/calendar',
      name: 'MemasAdminWebCalendar',
      component: MemasAdminWebCalendar,
      beforeEnter: primaryUserRegistered
    },
    {
      path: '/Error',
      name: 'ErrorPage',
      component: ErrorPage
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback,
      props: (route) => ({
        query: route.query.code
      })
    },
    {
      path: '/mscallback',
      name: 'MicrosoftCallback',
      props: (route) => ({
        query: route.query
      }),
      component: MicrosoftCallback
    },
    {
      path: '/subscription/callback',
      name: 'SubscriptionCallback',
      component: SubscriptionCallback
    },
    {
      path: '/microsoftlogin',
      name: 'MicrosoftLogin',
      component: MicrosoftLogin
    },
    {
      path: '/gogllogin',
      name: 'GoogleLogin',
      //       beforeEnter: requireAuthentication,
      component: GoogleLogin
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log('ROUTER BEFORE EACH FROM (%s) TO (%s)', from.name, to.name)
  console.log('ROUTER BEFORE EACH TO (%s)', to.fullPath)
  next()
})

function primaryUserRegistered(to, from, next) {
  let uStore = userStore()
  console.log('NAVIGATING TO (%s) (%j)', uStore.primaryuser.displayName, to)
  if (uStore.primaryuser.uid !== '' && uStore.primaryuser.displayName !== '') {
    next()
  } else {
    next({ name: 'EndUser' })
  }
}
export default router
